import dayjs from "dayjs";
import {
  LABEL_PLACEHOLDERS,
  OLD_PLACEHOLDER_AGENT_NAME,
  OLD_PLACEHOLDER_BALANCE_AMOUNT,
  OLD_PLACEHOLDER_BUSINESS_CODE,
  OLD_PLACEHOLDER_COLLECTION_PLACE,
  OLD_PLACEHOLDER_CUSTOMER_CONTACT,
  OLD_PLACEHOLDER_CUSTOMER_NAME,
  OLD_PLACEHOLDER_DELIVERY_DATE,
  OLD_PLACEHOLDER_DELIVERY_WEEK_DAY,
  OLD_PLACEHOLDER_DEPARTMENT,
  OLD_PLACEHOLDER_ITEM_DETAILS,
  OLD_PLACEHOLDER_ITEM_NAME,
  OLD_PLACEHOLDER_ITEM_REMARK,
  OLD_PLACEHOLDER_ORDER_NO,
  OLD_PLACEHOLDER_ORDER_TOTAL_UNIT,
  OLD_PLACEHOLDER_ORDER_UNIT_INDEX,
  OLD_PLACEHOLDER_PACKAGE_INDEX,
  OLD_PLACEHOLDER_PACKING_DATE,
  OLD_PLACEHOLDER_PACKING_PCS,
  OLD_PLACEHOLDER_RECEVING_DATE,
  OLD_PLACEHOLDER_RECEVING_WEEK_DAY,
  OLD_PLACEHOLDER_SERVICE_OPTION,
  OLD_PLACEHOLDER_SET_PCS_INDEX,
  OLD_PLACEHOLDER_SET_TOTAL_PCS,
  OLD_PLACEHOLDER_TOTAL_PACKAGE,
} from "./constants/label.js";
import translate from "./translate.js";

export default function (
  template,
  {
    businessCode,
    option,
    optionId,
    optionCode,
    subOptions,
    selectSteps,
    date,
    note,
    subType,
    product,
    orderNo,
    customer,
    unitIndex,
    totalUnit,
    unitTotalPcs,
    unitPcsIndex,
    totalBalance,
    timestamp,
    homeDelivery,
    collectionPlace,
    delivery,
    department,
    agent,
    packingPcs,
    index,
    total,
  },
  context
) {
  const { businessCodes, stores, webapps, serviceTypes } = context || {};

  let placeholder,
    protection = 100;

  do {
    protection--;
    placeholder = LABEL_PLACEHOLDERS.find((item) => template.indexOf(`@${item}`) >= 0);

    if (placeholder) {
      let replacement = "";
      switch (placeholder) {
        case OLD_PLACEHOLDER_BUSINESS_CODE:
          replacement = `${
            (businessCodes && businessCodes[businessCode]) ||
            (stores && stores[businessCode]) ||
            (webapps && webapps[businessCode]) ||
            ""
          }`;
          break;
        case OLD_PLACEHOLDER_ORDER_NO:
          replacement = `${orderNo || ""}`;
          break;
        case OLD_PLACEHOLDER_ORDER_TOTAL_UNIT:
          replacement = `${totalUnit || ""}`;
          break;
        case OLD_PLACEHOLDER_ORDER_UNIT_INDEX:
          replacement = `${unitIndex || ""}`;
          break;
        case OLD_PLACEHOLDER_SET_TOTAL_PCS:
          replacement = `${unitTotalPcs || ""}`;
          break;
        case OLD_PLACEHOLDER_SET_PCS_INDEX: {
          replacement = `${unitPcsIndex || ""}`;
          break;
        }
        case OLD_PLACEHOLDER_CUSTOMER_NAME:
          replacement = `${customer?.name || ""}`;
          break;
        case OLD_PLACEHOLDER_CUSTOMER_CONTACT:
          if (Array.isArray(customer?.tels)) {
            replacement = customer.tels.map(({ number, intl }) => intl || number).join(", ");
          }
          break;
        case OLD_PLACEHOLDER_ITEM_NAME: {
          replacement = `${(product && translate(product)) || ""}${subType ? `-${translate(subType)}` : ""}`;
          break;
        }
        case OLD_PLACEHOLDER_SERVICE_OPTION: {
          let options = [];

          if (optionCode) {
            options.push(optionCode);
          } else if (serviceTypes && serviceTypes[optionId]) {
            options.push(serviceTypes[optionId]);
          } else if (translate(option)) {
            options.push(translate(option));
          }

          if (subOptions) {
            subOptions.forEach(({ code }) => {
              if (code) {
                options.push(code);
              }
            });
          }

          replacement = options.join(" | ");
          break;
        }
        case OLD_PLACEHOLDER_RECEVING_DATE: {
          const receive = dayjs.unix(timestamp);
          replacement = receive.format("DD/MM");
          break;
        }
        case OLD_PLACEHOLDER_RECEVING_WEEK_DAY: {
          const receive = dayjs.unix(timestamp);
          replacement = receive.format("dd");
          break;
        }
        case OLD_PLACEHOLDER_DELIVERY_DATE: {
          if (delivery?.date) {
            const receive = dayjs(delivery?.date, "YYYY-MM-DD");
            replacement = receive.format("DD/MM");
          }
          break;
        }
        case OLD_PLACEHOLDER_DELIVERY_WEEK_DAY: {
          if (delivery?.date) {
            const receive = dayjs(delivery?.date, "YYYY-MM-DD");
            replacement = receive.format("dd");
          }
          break;
        }
        case OLD_PLACEHOLDER_BALANCE_AMOUNT: {
          replacement = totalBalance ? `BAL: ${totalBalance}` : "";
          break;
        }
        case OLD_PLACEHOLDER_ITEM_REMARK: {
          replacement = note ? `* ${note}` : "";
          break;
        }
        case OLD_PLACEHOLDER_ITEM_DETAILS: {
          replacement = (selectSteps || [])
            .filter((step) => step.printOnLabel)
            .map(({ value }) => {
              let content = ``;
              if (typeof value === "string") {
                content = value;
              } else if (Array.isArray(value)) {
                content = value
                  .map(({ code }) => code)
                  .filter((code) => code)
                  .join(", ");
              }
              return content;
            })
            .join(" | ");
          break;
        }
        case OLD_PLACEHOLDER_COLLECTION_PLACE: {
          replacement = homeDelivery
            ? `Home Delivery`
            : (businessCodes && businessCodes[collectionPlace]) ||
              (stores && stores[collectionPlace]) ||
              (webapps && webapps[collectionPlace]) ||
              "";
          break;
        }
        case OLD_PLACEHOLDER_DEPARTMENT: {
          replacement = `${department || ""}`;
          break;
        }
        case OLD_PLACEHOLDER_PACKING_PCS: {
          replacement = `${packingPcs || ""}`;
          break;
        }
        case OLD_PLACEHOLDER_AGENT_NAME: {
          replacement = agent?.name || ``;
          break;
        }
        case OLD_PLACEHOLDER_PACKAGE_INDEX: {
          replacement = index || ``;
          break;
        }
        case OLD_PLACEHOLDER_TOTAL_PACKAGE: {
          replacement = total || ``;
          break;
        }
        case OLD_PLACEHOLDER_PACKING_DATE: {
          if (date) {
            const receive = dayjs(date, "YYYY-MM-DD");
            replacement = receive.format("DD/MM");
          }
          break;
        }
      }

      const params = template.match(new RegExp(`@${placeholder}=\{(.*?)\}`, "i"));
      let regHolder;
      if (params) {
        regHolder = params[0];
        if (params[1] !== replacement) {
          replacement = "";
        }
      } else {
        regHolder = `@${placeholder}`;
      }

      template = template.replace(new RegExp(regHolder, "g"), replacement || "");
    }
  } while (placeholder && protection > 0);

  template = template.trim();
  template = template.replace(/ {1,}/g, " ");

  return template;
}
